import type { CatalogTree } from '../types';

export const components = {
  ChipEditor: {
    remove: '{chip} kaldır',
    empty: 'Boş bırakılamaz.',
  },
  HolidayList: {
    label: 'Tatil günleri',
    day: 'Eklenecek tatil günü',
    add: 'Ekle',
    remove: '{day} kaldır',
  },
  PlaceholderChips: {
    label: 'Kullanılabilir yer tutucular',
  },
  WeeklyScheduleEditor: {
    weekday: {
      mon: 'Pazartesi',
      tue: 'Salı',
      wed: 'Çarşamba',
      thu: 'Perşembe',
      fri: 'Cuma',
      sat: 'Cumartesi',
      sun: 'Pazar',
    },
    from: 'Başlangıç',
    to: 'Bitiş',
    add: 'Saat aralığı ekle',
    remove: 'Saat aralığını kaldır',
  },
  ModeControl: {
    mode: {
      auto: 'Otomatik',
      draft: 'Taslak',
      off: 'Kapalı',
    },
    meaning: {
      auto: 'Otomatik: asistan doğrudan yanıtlar.',
      draft: 'Taslak: asistan yazar, personel onaylayıp gönderir.',
      off: 'Kapalı: yalnızca personel yanıtlar.',
    },
  },
  TestResultChecklist: {
    check: {
      permissions: 'İzinler',
      prerequisite: 'Eklenti',
      egress: 'Erişim',
      sample_read: 'Örnek okuma',
      message_access: 'Bağlı araçlar mesaj erişimi',
      other: 'Diğer kontrol',
      payment_method: 'Ödeme yöntemi',
      name_status: 'Görünen ad',
      is_on_biz_app: 'WhatsApp Business uygulaması',
      webhook_subscription: 'Webhook aboneliği',
    },
    passed: 'Başarılı',
    failed: 'Başarısız',
    prerequisiteMissing:
      'Mağazanızda {prerequisite} etkin değil. Etkinleştirip Yeniden dene deyin.',
    retry: 'Yeniden dene',
  },
  SyncProgress: {
    doneOfTotal: '{done} / {total}',
    records: '{count} kayıt',
    waiting: 'Sırada',
    notInRun: 'Bu aktarımda yok',
  },
  PlanPicker: {
    interval: 'Faturalama dönemi',
    intervalOption: {
      monthly: 'Aylık',
      annual: 'Yıllık',
    },
    plan: 'Plan',
    pricePerMonth: '{price} / ay',
    pricePerYear: '{price} / yıl',
    seats: '{count} kullanıcı',
    channels: '{count} kanal',
    allowance: 'Asistan kullanımı: {allowance}',
    allowanceUnits: '{count} birim',
    unlimited: 'Sınırsız',
    trial: '{n} gün deneme',
    discountCode: 'İndirim kodu',
  },
  ProductPicker: {
    variant: 'Varyant',
  },
  OutcomeSheet: {
    title: 'Sonuç',
    kind: 'Sonuç',
    sold: 'Satıldı',
    lost: 'Kaybedildi',
    amount: 'Tutar',
    products: 'Ürünler',
    reason: 'Neden',
    save: 'Kaydet',
  },
  ThreadView: {
    typing: 'Asistan yazıyor…',
  },
  ConnectFlow: {
    connect: 'Bağlan',
    expired: 'Bağlantı isteğinin süresi doldu; yeniden başlatın.',
    egressIps: 'Bu IP adreslerini mağaza panelinizde izin listesine ekleyin',
  },
  PushDeviceCard: {
    title: 'Bu cihazda bildirimler',
    switch: 'Bu cihazda bildirim al',
    unsupported: 'Bu tarayıcı bildirimleri desteklemiyor.',
    denied: 'Bildirimler tarayıcı ayarlarından engellenmiş.',
    deniedHint:
      'Açmak için tarayıcınızın site ayarlarında bu panelin bildirim iznini "İzin ver" yapın, sonra sayfayı yenileyin.',
    iosOnlyInstalled: 'Bildirimler yalnızca ana ekrana eklenen uygulamada çalışır.',
    iosInstallHint: "Safari'de Paylaş → Ana Ekrana Ekle ile paneli yükleyin, sonra oradan açın.",
    failed: 'Bildirim ayarı değiştirilemedi. Lütfen tekrar deneyin.',
  },
} as const satisfies CatalogTree;
